import {connect} from 'react-redux'
import {autofill, submit} from 'redux-form'
import {PaginatorWithResult} from 'tm/employees/list/SearchForm'
import {formName, selector} from 'tm/employees/list/utils'

const mapStateToProps = (state) => ({
  count: state.employees.list.count,
  isLoading: state.employees.list.loading,
  page: selector(state, 'page'),
})
const mapDispatchToProps = (dispatch) => ({
  onClick: (page) => {
    dispatch(autofill(formName, 'page', page.toString()))
    dispatch(submit(formName))
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(PaginatorWithResult)
